<section class="panel widget-container">
  <header class="panel-heading">
    <h5 class="panel-title">Contact</h5>
  </header>

  <mojo-picture [imageUrl]="getImageUrl()"></mojo-picture>
</section>
